import { useState, useEffect } from "react";
import { Card, Tooltip, Badge, Modal } from "antd";
import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CATEGORY_COLORS } from "./colors";
import OrganizationModalContent from "./OrganizationModalContent";

export default function OrganizationCard({ title, total, breakdown, color, dashboardData, modalOrganizacionTipo, setModalOrganizacionTipo }) {
  const [mainModalOpen, setMainModalOpen] = useState(false);
  const [subModal, setSubModal] = useState({ open: false, item: null });

  useEffect(() => {
    if (!modalOrganizacionTipo) return;
    if (modalOrganizacionTipo === "Organizaciones") {
      setMainModalOpen(true);
    }
    else {
      const item = breakdown.find((b) => b.type === modalOrganizacionTipo);
      if (item) {
        setSubModal({ open: true, item });

      }
    }
  }, [modalOrganizacionTipo]);

  const handleSubModalOpen = (item) => {
    setSubModal({ open: true, item });

  };

  return (
    <Card
      style={{ background: color, color: "#fff", borderRadius: 8 }}
      styles={{
        header: {
          color: "#fff",
        },
        body: {
          padding: 16,
        },
      }}
      title={
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <FontAwesomeIcon icon={faBuilding} />
          {title}
        </span>
      }
    >
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
        {/* TOTAL CARD */}
        <div
          onClick={() => setMainModalOpen(true)}
          style={{
            cursor: "pointer",
            textAlign: "center",
            flex: 1,
            minWidth: 120,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              fontSize: 32,
              fontWeight: "bold",
              background: "rgba(255,255,255,0.2)",
              borderRadius: "50%",
              width: 80,
              height: 80,
              margin: "0 auto 8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s",
            }}
          >
            {total}
          </div>
          <div style={{ opacity: 0.9, fontSize: 14 }}>{title}</div>
        </div>

        {/* SUBTOTALES */}
        <div style={{ flex: 2, minWidth: 200, marginLeft: 24 }}>
          {breakdown.map((item, index) => {
            return (
              <Tooltip
                key={index}
                title={
                  <div>
                    <strong>Organizaciones {item.label}</strong>
                    {item.type === "FAO" && (
                      <div style={{ fontSize: 11, marginTop: 6 }}>
                        {dashboardData.organizaciones.FAO.slice(0, 3).map((org, idx) => (
                          <div key={idx}>• {org.sigla}</div>
                        ))}
                        {dashboardData.organizaciones.FAO.length > 3 && (
                          <div style={{ color: "#999" }}>... y más</div>
                        )}
                      </div>
                    )}
                  </div>
                }
              >
                <div
                  onClick={() => handleSubModalOpen(item)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: item.color,
                    borderRadius: 999,
                    padding: "6px 12px",
                    marginBottom: 8,
                    cursor: "pointer",
                    border: "1px solid rgba(255,255,255,0.2)",
                    transition: "transform 0.2s",
                  }}
                >
                  <span style={{ fontSize: 13, color: "#fff" }}>{item.value}</span>
                  <span style={{ fontSize: 13, color: "#fff", opacity: 0.9 }}>{item.label}</span>
                </div>
              </Tooltip>
            );
          })}
        </div>
      </div>

      {/* MODAL PRINCIPAL */}
      <Modal
        open={mainModalOpen}
        onCancel={() => {
          setMainModalOpen(false);
          setModalOrganizacionTipo(null); // 🔁 Limpia para permitir reabrir
        }}
        footer={null}
        width={1000}
        title={
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <FontAwesomeIcon icon={faBuilding} /> {/* Cambio aquí */}
            Todas las Organizaciones ({total})
          </span>
        }
        styles={{
          body: {
            maxHeight: "70vh",
            overflowY: "auto",
          },
        }}
      >
        <p>Lista completa de todas las organizaciones por categoría</p>
        <OrganizationModalContent dashboardData={dashboardData} />
      </Modal>

      {/* MODAL SECUNDARIO POR CATEGORÍA */}
      <Modal
        open={subModal.open}
        onCancel={() => {
          setSubModal({ open: false, item: null });
          setModalOrganizacionTipo(null);
        }}
        footer={null}
        width={800}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FontAwesomeIcon icon={faBuilding} style={{ color: '#555' }} />
            <span>Organizaciones - {subModal.item?.label}</span>
          </div>
        }
      >
        <p>
          Lista detallada de organizaciones de <strong>{subModal.item?.label}</strong>
        </p>

        <div
          style={{
            maxHeight: "60vh",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {dashboardData.organizaciones[subModal.item?.type] &&
            dashboardData.organizaciones[subModal.item?.type].length > 0 ? (
            dashboardData.organizaciones[subModal.item?.type].map((org, idx) => (
              <Card
                key={idx}
                size="small"
                style={{
                  marginBottom: 12,
                  backgroundColor: "#f9f9f9",
                  padding: 10,
                  borderLeft: `4px solid ${CATEGORY_COLORS[subModal.item?.type]?.borderColor || "#ccc"}`
                }}
                hoverable
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 16,
                    marginLeft: 16,
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <h6
                      style={{
                        fontWeight: 600,
                        color: CATEGORY_COLORS[subModal.item?.type]?.textColor || "#000",
                        marginBottom: 4,
                      }}
                    >
                      {org.organizacion}
                    </h6>

                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      <Badge
                        count={org.sigla}
                        style={{
                          backgroundColor: CATEGORY_COLORS[subModal.item?.type]?.badgeBackground || "#999",
                          color: "#fff",
                          fontSize: 12,
                          marginTop: 5,
                        }}
                      />
                      {org.Nit && (
                        <span
                          style={{
                            fontSize: 12,
                            backgroundColor: "#e5e5e5ff",
                            padding: "2px 6px",
                            borderRadius: 4,
                            color: "#000",
                          }}
                        >
                          NIT: {org.Nit}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 12, color: "#999" }}>#{idx + 1}</div>
                </div>
              </Card>
            ))
          ) : (
            <Card
              style={{
                textAlign: "center",
                padding: 24,
                borderLeft: `4px solid ${CATEGORY_COLORS[subModal.item?.type]?.borderColor || "#ddd"}`,
              }}
            >
              <FontAwesomeIcon
                icon={faBuilding}
                style={{
                  fontSize: 36,
                  opacity: 0.5,
                  color: CATEGORY_COLORS[subModal.item?.type]?.textColor || "#888",
                }}
              />
              <h4 style={{ color: CATEGORY_COLORS[subModal.item?.type]?.textColor || "#333" }}>
                Información en proceso
              </h4>
              <p style={{ fontSize: 13, color: "#666" }}>
                Los datos detallados de estas organizaciones están siendo procesados y estarán disponibles próximamente.
              </p>
            </Card>
          )}
        </div>
      </Modal>
    </Card>
  );
}
